import React, { FC } from 'react';

import { ConfirmModal } from 'common/components';
import { CloseWithBorderIcon } from 'applicaiton/assets';

import { DeleteConfirmModalProps } from './models';
import { ModalStyled, OptionsList } from './styles';

/**
 * A modal component that displays a confirmation message with options for deletion.
 * @param props The properties of the DeleteConfirmModal component.
 */
const DeleteConfirmModal: FC<DeleteConfirmModalProps> = ({
  opened,
  onClose,
  onSubmit,
  title,
  name,
  subTitle,
  options,
  isLoading,
}) => {
  return (
    <ConfirmModal
      opened={opened}
      onClose={onClose}
      onSubmit={onSubmit}
      styleType="error"
      isLoading={isLoading}
    >
      <ModalStyled>
        <h1>
          {title} {name && <span>{name}</span>}
        </h1>
        <h2>{subTitle}</h2>
        <OptionsList>
          {options.map((item, index) => (
            <div key={`delete-option-${index}`}>
              <CloseWithBorderIcon />
              <p>{item}</p>
            </div>
          ))}
        </OptionsList>
      </ModalStyled>
    </ConfirmModal>
  );
};

export default DeleteConfirmModal;
